// extracted by mini-css-extract-plugin
export default {"container":"YQIGHr","iconWrapper":"cm_Da9"};